// Finite-number coercion helper for chart/summary math. Guarantees a usable
// number so null / undefined / "" / non-numeric / NaN / Infinity never leak
// into arithmetic and produce "NaN" in the UI (e.g. "NaN cal over target").
export function num(value, fallback = 0) {
  var n = typeof value === 'number' ? value : parseFloat(value);
  return Number.isFinite(n) ? n : fallback;
}

// Clamp a value into [min, max] after finite-coercion (used for SVG coords so a
// malformed data point can never render off-canvas or as NaN).
export function clamp(value, min, max, fallback = 0) {
  var n = num(value, fallback);
  if (n < min) return min;
  if (n > max) return max;
  return n;
}

export default num;
